<script lang="ts" setup>
import { ParagraphContact, ParagraphContactAccordionItem } from '~/api/graphql/generated'

const props = defineProps<{
  entity: ParagraphContact
}>()

const items = props.entity.fieldItems?.map((item) => {
  return {
    title: (item?.entity as ParagraphContactAccordionItem).fieldTitle || '',
    content: (item?.entity as ParagraphContactAccordionItem).fieldFullHtml?.processed,
    latitude: (item?.entity as ParagraphContactAccordionItem).fieldLatitude,
    longitude: (item?.entity as ParagraphContactAccordionItem).fieldLongitude,
  }
})
</script>

<template>
  <Section>
    <div class="t-10 t-o-1 tl-7 tl-o-0 ds-o-1">
      <Accordion>
        <AccordionItem v-for="(item, index) in items" :key="index" :index="index" :title="item.title">
          <TextSpecial v-if="item.content" :text="item.content" />
          <GoogleMap v-if="item.latitude && item.longitude" :lat="item.latitude" :lng="item.longitude" />
        </AccordionItem>
      </Accordion>
    </div>
  </Section>
</template>
